import { CategoryGroupDetailPage } from "@/features/category-group/pages/CategoryGroupDetailPage";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/admin/category-group/$id/detail")({
	component: RouteComponent,
});

function RouteComponent() {
	const { id } = Route.useParams();
	return <CategoryGroupDetailPage id={id} />;
}
